var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JSONTextArea',{on:{"validate":function($event){_vm.isJSONValid = $event}},model:{value:(_vm.jsonAsString),callback:function ($$v) {_vm.jsonAsString=$$v},expression:"jsonAsString"}})}
var staticRenderFns = []

export { render, staticRenderFns }